import React, { useState } from "react";
import { FaPenFancy, FaCalendarAlt } from "react-icons/fa";
import { Link } from "react-router-dom";

export default function BlogList() {
  const [currentPage, setCurrentPage] = useState();

  return (
    <>
      <OneBlog
        title="Dolore duis elit aliqua"
        img={require("../assets/blogs/blog01.png")}
        description={
          "Dolore duis elit aliqua aliquip consequat aliquip consequat fugiat eiusmod aliqua ullamco. In fugiat laborum dolore est velit eu eu esse culpa nulla enim. Ad fugiat ut et voluptate fugiat.Voluptate culpa ullamco deserunt magna Lorem tempor ea laboris id proident. Proident ex excepteur ullamco enim ex. Ipsum sit veniam ad quis consectetur dolore labore incididunt cupidatat veniam enim incididunt magna. Sunt aliquip ipsum quis sit cillum nostrud amet."
        }
      />
      <OneBlog
        title="Irure Consectetur Adipisicing sunt cillum velit"
        img={require("../assets/blogs/blog02.png")}
        description={
          "Ad culpa dolor aliqua irure consectetur adipisicing sunt cillum velit irure nulla sunt. Occaecat in ullamco do eiusmod occaecat nulla ad id ipsum. Consequat ut aliquip elit anim eiusmod minim incididunt et occaecat anim non."
        }
      />
      <div className=" text-sub_text_color mx-auto h-8 w-64 flex items-center ">
        <button
          onClick={() => setCurrentPage(1)}
          className={`${
            currentPage === 1 && "bg-pink text-white"
          } border mx-4 px-2 rounded-sm`}
        >
          1
        </button>
        <button
          onClick={() => setCurrentPage(2)}
          className={`${
            currentPage === 2 && "bg-pink text-white"
          } border mx-4 px-2 rounded-sm`}
        >
          2
        </button>
      </div>
    </>
  );
}

function OneBlog({ title, description, img }) {
  return (
    <div className=" mb-8">
      {/* image container */}
      <div className=" w-full h-[25rem] bg-slate-400 overflow-hidden rounded-sm">
        <img alt="" className=" w-full h-full block object-cover" src={img} />
      </div>
      {/* icons container */}
      <div className="my-3 text-sm flex font-semibold">
        <div className="flex items-center">
          <FaPenFancy color="#FB2E86" />
          <div className=" py-1 bg-[#FFE7F9] rounded-md inline-block px-3 ml-3">
            Ahmed azad
          </div>
        </div>
        <div className="flex items-center ml-5">
          <FaCalendarAlt color="#FFA454" />
          <div className=" py-1 bg-[#FFECE2] rounded-md inline-block px-3 ml-3">
            20/2/2022
          </div>
        </div>
      </div>
      {/* title */}
      <h2 className=" text-2xl font-bold mb-2">{title}</h2>
      {/* description */}
      <p className=" text-sub_text_color text-sm overflow-hidden overflow-ellipsis whitespace-nowrap font-fontTwo mb-2">
        {description}
      </p>
      <Link
        to="../blog/jkldf"
        className=" text-sub_text_color hover:text-black"
      >
        Read More
      </Link>
    </div>
  );
}
